import React, { useEffect, useState } from 'react';
import { FaFacebook } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { FaWhatsapp } from "react-icons/fa";
import { useMediaQuery } from '@react-hook/media-query';

//Iconos de las redes sociales que usamos por toda la web
const IconosRedes = (props) => {
    const [iconSize, setIconSize] = useState(props.contacto ? '27' : '25');
    const isWideScreen = useMediaQuery('(max-width: 768px)');

    useEffect(() => {
        if (isWideScreen && props.header === "true") {
            setIconSize('15');
        } else {
            setIconSize(props.contacto ? '27' : '25');
        }
    }, [isWideScreen, props.contacto, props.header]);

    const iconStyle = {
        margin: '0px 5px',
        fontSize: `${iconSize}px`,
        color: props.contacto ? '#EE805D' : '#bbb'
    };

    switch (props.id) {
        case 'facebook':
            return <FaFacebook style={iconStyle} />;
        case 'instagram':
            return <BsInstagram style={iconStyle} />;
        case 'whatsapp':
            return <FaWhatsapp style={iconStyle} />;
        default:
            return null;
    }
}

export default IconosRedes;
